import { css } from '@emotion/react';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Season } from '../../../../../../types/ElPrixContextData';

export const elevationChartStyles = (season?: Season) => css`
  .highcharts-point:hover {
    fill: ${season === 'winter' ? nafColor.information.information : nafColor.information.successDark} !important;
  }
  .highcharts-tooltip > span {
    background: white !important;
  }
  .highcharts-tooltip > span > div > b {
    font-weight: bold;
    font-family: questa-sans;
    text-transform: uppercase;
    margin: 0;
    font-size: 1rem;
  }
  .highcharts-tooltip > span > div {
    padding: ${spacing.space4} ${spacing.space8};
  }
  .highcharts-tooltip > span > div > div {
    margin-top: 4px;
  }
  .highcharts-tooltip > span > div > div > p {
    font-family: questa-sans;
    font-size: 1rem;
    margin: 0;
  }
  .summer:hover,
  .longer:hover {
    fill: ${nafColor.information.successDark} !important;
  }
  .winter:hover {
    fill: ${nafColor.information.information} !important;
  }
  .shorter:hover {
    fill: ${nafColor.information.errorDark} !important;
  }
  .not-reached:hover {
    fill: ${nafColor.neutral.neutral3} !important;
  }
`;
